export default __webpack_public_path__ + "static/media/support_black.35976db7.svg";